import { useContext } from 'react';

import { SidecarRouterContext } from '$components/sidecar-router/sidecar-router-context';

export function useSidecarRoute() {
  const { route } = useContext(SidecarRouterContext);
  return route;
}
